__turbopack_context__.v({
  "dateText": "BCyzjq_dateText",
  "dateTitle": "BCyzjq_dateTitle",
  "wrapper": "BCyzjq_wrapper",
});
